module.exports = __webpack_public_path__ + "assets/img/tenExtract.51cd6416.png";